<template>
    <h1 class="heading-2">Perfil</h1>
    <div class="user-profile-form">
        <form
            @submit.prevent="getAccountData()"
            class="row"
            autocomplete="on"
            method="post"
            aria-describedby="Professional Data"
        >
            <div class="add-profile-pic">
                <div class="baseimage_preview">
                    <div
                        class="element-image-preview"
                        id="element-image-preview"
                        :style="`background:url('${imgdefaultaccount}') no-repeat center;`"
                    >
                        <label
                            for="professional_img_perfil"
                            class="form-label btnplus d-flex flex-column align-items-center justify-content-center"
                            ><img
                                :src="`${imgdefaultpath}/camera.svg`"
                                alt="add picture"
                        /></label>
                    </div>
                </div>
                <input
                    @change="
                        multipleFileData($event, 'professional_img_perfil')
                    "
                    class="form-control input-file-account"
                    name="files"
                    type="file"
                    id="professional_img_perfil"
                    accept="image/*"
                    ref="professional_img_perfil"
                    data-filealt="professional_img_perfil"
                />
            </div>

            <div class="input-label-wrapper">
                <label for="name" class="form-label">Nome Completo*</label>
                <input
                    @focusin="inputValidation('name', name)"
                    @focusout="inputValidation('name', name)"
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder=""
                    v-model="name"
                    maxlength="300"
                />
            </div>

            <div class="input-label-wrapper">
                <label for="contact" class="form-label">Telemóvel*</label>
                <input
                    @focusin="inputValidation('contact', contact)"
                    @focusout="inputValidation('contact', contact)"
                    type="text"
                    class="form-control"
                    id="contact"
                    placeholder=""
                    v-model="contact"
                    maxlength="9"
                />
            </div>

            <div class="input-label-wrapper">
                <label for="address" class="form-label">Morada*</label>
                <input
                    @focusin="inputValidation('address', address)"
                    @focusout="inputValidation('address', address)"
                    type="text"
                    class="form-control"
                    id="address"
                    placeholder=""
                    v-model="address"
                    maxlength="400"
                />
            </div>

            <div class="input-label-wrapper double-input-row">
                <div class="flex-1">
                    <label for="postalcode" class="form-label"
                        >Código Postal*</label
                    >
                    <input
                        @focusin="inputValidation('postalcode', postalcode)"
                        @focusout="inputValidation('postalcode', postalcode)"
                        type="text"
                        class="form-control"
                        id="postalcode"
                        v-model="postalcode"
                        maxlength="8"
                    />
                </div>

                <div class="flex-1">
                    <label for="city" class="form-label">Cidade*</label>
                    <input
                        @focusin="inputValidation('city', city)"
                        @focusout="inputValidation('city', city)"
                        type="text"
                        class="form-control"
                        id="city"
                        v-model="city"
                        maxlength="100"
                    />
                </div>
            </div>

            <div class="input-label-wrapper">
                <label for="nif" class="form-label">NIF*</label>
                <input
                    @focusin="inputValidation('nif', nif)"
                    @focusout="inputValidation('nif', nif)"
                    type="text"
                    class="form-control"
                    id="nif"
                    placeholder=""
                    maxlength="9"
                    v-model.number="nif"
                />
            </div>

            <div class="input-label-wrapper">
                <div class="form-check">
                    <input
                        @click="billingAddressIndicate()"
                        class="form-check-input"
                        type="checkbox"
                        id="gridCheck"
                        :checked="billingAddress"
                    />
                    <label class="form-check-label" for="gridCheck">
                        Utilizar estes dados para faturação
                    </label>
                </div>
            </div>

            <template v-if="!billingAddress">
                <fieldset>
                    <legend>Morada de Faturação</legend>

                    <div class="input-label-wrapper">
                        <label for="address_billing" class="form-label"
                            >Morada *</label
                        >
                        <input
                            @focusin="
                                inputValidation(
                                    'address_billing',
                                    address_billing
                                )
                            "
                            @focusout="
                                inputValidation(
                                    'address_billing',
                                    address_billing
                                )
                            "
                            type="text"
                            class="form-control"
                            id="address_billing"
                            placeholder=""
                            v-model="address_billing"
                            maxlength="400"
                        />
                    </div>
                    <div class="input-label-wrapper double-input-row">
                        <div class="flex-1">
                            <label for="postalcode_billing" class="form-label"
                                >Código Postal *</label
                            >
                            <input
                                @focusin="
                                    inputValidation(
                                        'postalcode_billing',
                                        postalcode_billing
                                    )
                                "
                                @focusout="
                                    inputValidation(
                                        'postalcode_billing',
                                        postalcode_billing
                                    )
                                "
                                type="text"
                                class="form-control"
                                id="postalcode_billing"
                                v-model="postalcode_billing"
                                maxlength="9"
                            />
                        </div>
                        <div class="flex-1">
                            <label for="city_billing" class="form-label"
                                >Cidade *</label
                            >
                            <input
                                @focusin="
                                    inputValidation(
                                        'city_billing',
                                        city_billing
                                    )
                                "
                                @focusout="
                                    inputValidation(
                                        'city_billing',
                                        city_billing
                                    )
                                "
                                type="text"
                                class="form-control"
                                id="city_billing"
                                v-model="city_billing"
                                maxlength="100"
                            />
                        </div>
                    </div>
                </fieldset>
            </template>

            <button
                type="submit"
                class="btn btn-primary w-100 btn-filled-blue"
                :disabled="disabledsequence"
            >
                <p class="button-body">Avançar</p>
            </button>
        </form>
    </div>
</template>
<script>
//Set Use Strict
"use strict";

import fetchData from "./../../../fetchData.js";
import htmlElements from "./../../../htmlElements.js";
import inputValidation from "./../../../validationInputs.js";

export default {
    name: "ProfessionalForm",
    emits: ["form-data"],
    props: {
        routine: {
            type: String,
            required: true,
        },
        validation: {
            type: Function,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
        onboardsequence: {
            type: Function,
            required: false,
        },
        imgdefaultaccount: {
            type: String,
            required: true,
        },
        imgdefaultpath: {
            type: String,
            required: true,
        },
        renderMessage: {
            type: Function,
            required: true,
        },
    },
    data: () => {
        return {
            name: "",
            contact: "",
            address: "",
            postalcode: "",
            city: "",
            nif: "",
            formData: {
                data: {
                    file: {},
                },
                billing_address: {},
            },
            billingAddress: true,
            address_billing: "",
            postalcode_billing: "",
            city_billing: "",
            alertmegabyte: 1024 * 1000 * 1.2,
            filedataformlist: [],
            filedataformitemlist: {},
            filewidthheightlist: [],
            filedataformlistMediaData: [],
            disabledsequence: true,
        };
    },
    created() {
        //Set Value for Disable
        this.disabledsequence = this.disabled;
    },
    mounted() {},
    methods: {
        renderMessageMethod(message, classname = "danger") {
            this.renderMessage(message, classname);
        },
        inputValidation(inputid, inputvalue) {
            //Check Value
            if (inputvalue === "") {
                return;
            }

            //Check Input Id
            switch (inputid) {
                //Postalcode
                case "postalcode":
                case "postalcode_billing":
                    //Check Length
                    this.disabledsequence =
                        (inputvalue.length === 8 && inputvalue.includes("-")) ||
                        (inputvalue.length === 7 && !inputvalue.includes("-"))
                            ? false
                            : true;

                    break;

                //Nif
                case "nif":
                   
                    //Check Length
                    if (inputvalue.toString().length === 9) {
                        this.disabledsequence = inputValidation.validNameCases(
                            12,
                            inputvalue
                        )
                            ? false
                            : true;

                        //Check Nif structure
                        if(!this.disabledsequence){

                            this.disabledsequence = inputValidation.isValidNif(inputvalue);

                        }

                    } else {
                        this.disabledsequence = true;
                    }  

                    break;
            }

            //Show Error Message
            if (
                this.disabledsequence &&
                ["postalcode", "postalcode_billing", "nif"].includes(inputid)
            ) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );

                return;
            }

            return this.$props.validation(inputid, inputvalue);
        },
        getAccountData() {
            //Required Inputs
            let requiredInputsList = [
                "name",
                "contact",
                "address",
                "postalcode",
                "city",
                "nif",
            ];

            //Required
            let required = this.checkRequiredInputs(requiredInputsList);

            //Check Required
            if (!required) {
                //Send Message
                this.renderMessageMethod(
                    "Todos os campos com * são de preenchimento obrigatório"
                );

                return;
            }

            //===> Develop one more security layer for NIF
            if (this.nif.length < 9 || this.postalcode.length < 7) {
                //Send Message
                this.renderMessageMethod("O valor informado é inválido");

                return;
            }

            //Get Form Data
            this.formData.data.name = this.name.trim();
            this.formData.data.contact = this.contact.trim();
            this.formData.data.nif = this.nif;
            this.formData.data.address = this.address.trim();
            this.formData.data.postalcode = this.postalcode.trim();
            this.formData.data.city = this.city.trim();

            //Set BillingAddress
            if (this.billingAddress) {
                this.formData.billing_address.address =
                    this.formData.data.address;
                this.formData.billing_address.postalcode =
                    this.formData.data.postalcode;
                this.formData.billing_address.city = this.formData.data.city;
            } else {
                //Required Inputs
                requiredInputsList = [
                    "address_billing",
                    "postalcode_billing",
                    "city_billing",
                ];

                //Required
                required = this.checkRequiredInputs(requiredInputsList);

                //Check Required
                if (!required) {
                    //Send Message
                    this.renderMessageMethod(
                        "Todos os campos com * são de preenchimento obrigatório"
                    );

                    return;
                }

                this.formData.billing_address.address =
                    this.address_billing.trim();
                this.formData.billing_address.postalcode =
                    this.postalcode_billing.trim();
                this.formData.billing_address.city = this.city_billing.trim();
            }

            //Check Account Image
            if (this.filedataformlist.length > 0) {
                Object.assign(
                    this.formData.data.file,
                    this.filedataformlist[0]
                );
            }

            //Check Routine
            switch (this.routine) {
                //Website
                case "website":
                    //Enable Sequence
                    this.$props.onboardsequence("contrato");

                    break;
            }

            return this.$emit("form-data", this.formData);
        },
        billingAddressIndicate() {
            //Set new Conditional
            this.billingAddress = this.billingAddress ? false : true;
        },
        createImage(inputid, height = "75", width = "150") {
            //Create LI Element
            return htmlElements.createElement("img", {
                class: `preview_${inputid} my-3`,
                id: `preview_${inputid}`,
                src: "",
                height: height,
                width: width,
                alt: "preview",
                style: "object-fit: scale-down;",
            });
        },
        multipleFileData(element, inputid) {
            //Set Disabled
            element.target.setAttribute("disabled", true);

            //FileData Item Object Clean Variable
            this.filedataformitemlist = {};

            //Get Data from File
            let filedata = element.target.files;

            //Remove Old Preview Image
            document.getElementById("element-image-preview").style = "";

            //Create Image Element
            //let img = this.createImage(inputid);

            //Get Data from Multiple File
            [...filedata].forEach((value, index) => {
                //Check fileSize
                if (value.size >= Math.abs(this.alertmegabyte)) {
                    //Send Message
                    this.renderMessageMethod(
                        "Please upload a smaller file up to 1MG"
                    );

                    //Enabled Input
                    element.target.removeAttribute("disabled");

                    //Disabled Submit button
                    //this.disabled = true;

                    return;
                }

                //Check type of the file
                if (!value.type.includes("image")) {
                    //Send Message
                    this.renderMessageMethod(
                        "Please only send image type file"
                    );

                    //Enabled Input
                    element.target.removeAttribute("disabled");

                    return;
                }

                //Structure File Data Object
                this.filedataformitemlist = {
                    fileindex: index,
                    filename: value.name.trim(),
                    filedata: {},
                };

                //Get Width and Height from Image
                let reader = new FileReader();
                reader.readAsDataURL(value);
                reader.onload = (e) => {
                    const src = e.target.result;

                    const img = new Image();

                    img.onload = () => {
                        //Set FileDimension
                        let filedimension = {
                            width: img.width,
                            height: img.height,
                        };

                        //Set File width and height
                        this.filewidthheightlist.push(filedimension);

                        return this.filewidthheightlist;
                    };

                    img.onerror = (error) => {
                        throw new Error(error);
                    };

                    img.src = src;
                };

                //Create Event Listenner
                reader.addEventListener(
                    "load",
                    () => {
                        // convert image file to base64 string
                        //img.src = reader.result;
                        //Set Preview Image Content
                        document.getElementById(
                            "element-image-preview"
                        ).style.background = `url('${reader.result}') no-repeat center`;
                    },
                    false
                );

                //Get base64 Promise
                let file64Promise = fetchData.toBase64(value);

                //Get Data from Promise
                file64Promise
                    .then((val64) => {
                        //Check File Alt
                        //let filealtname = element.target.getAttribute('data-filealt') + '_' + value.name.toLocaleLowerCase();

                        //Structure File Data Object
                        this.filedataformitemlist.filedata = {
                            type: value.type.replace("image/", ""),
                            filealt: element.target
                                .getAttribute("data-filealt")
                                .trim(),
                            file64: val64,
                            filealldimensions: this.filewidthheightlist[index]
                                ? this.filewidthheightlist[index]
                                : null,
                            filename: value.name.trim(),
                        };

                        //Check Old Image Data and remove old image data
                        //this.oldImageUpdateRoutine(element.target.getAttribute('data-storeid'), this.filedataformitemlist.filedata);

                        //Push Data
                        if (this.filedataformlist.length === 0) {
                            this.filedataformlist.push(
                                this.filedataformitemlist
                            );
                        } else {
                            //Clean Old Image Data
                            this.filedataformlist = [];

                            //Push New Data Image
                            this.filedataformlist.push(
                                this.filedataformitemlist
                            );
                        }

                        //Remove Disabled Attribute
                        element.target.removeAttribute("disabled");

                        //Send Data for Storage File
                        return this.filedataformlist;
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            });
        },
        oldImageUpdateRoutine(storeid, newimgdata) {
            //Check Old Image Data
            if (
                this.routine === "PUT" &&
                this.filedataformlistMediaData.length > 0
            ) {
                //Index old image
                //let indexOldImg = null;

                this.filedataformlistMediaData.forEach(
                    (valoldimg, indexoldimg) => {
                        if (valoldimg.media.store_id === parseInt(storeid)) {
                            //indexOldImg = indexoldimg;

                            //Update FileData
                            valoldimg.filedata.newimg = newimgdata;
                        }
                    }
                );

                /* if(indexOldImg !== null){

                        //Remove old data from FileData
                        this.filedataformlistMediaData.splice(indexOldImg, 1);

                    } */
            }
        },
        checkRequiredInputs(requiredInputsList) {
            //Required
            let required = true;

            Object.keys(this.$data).forEach((valkey) => {
                const dataKey = Object.getOwnPropertyDescriptor(
                    this.$data,
                    valkey
                );

                //Check Empty Inputs
                if (
                    requiredInputsList.includes(valkey) &&
                    dataKey.value === ""
                ) {
                    required = false;
                }
            });

            return required;
        },
    },
    computed: {
        formDataComputed() {
            return this.formData;
        },
        billingAddressComputed() {
            return this.billingAddress;
        },
        computedFiledataFormList() {
            return this.filedataformlist;
        },
        computedFileFormItemList() {
            return this.filedataformitemlist;
        },
        computedFileWidthHeightList() {
            return this.filewidthheightlist;
        },
    },
    watch: {
        formDataComputed() {},
        billingAddressComputed() {},
        computedFiledataFormList() {},
        computedFileFormItemList() {},
        computedFileWidthHeightList() {},
    },
};
</script>
